module.exports = __webpack_public_path__ + "img/Group 5903.75cb7006.svg";